export const SCHEMA_KEY_INFO = [
  {
    table_id: 'ced_output_key_info',
    col_id: 'casing_id',
    col_name: 'Casing ID',
    col_desc: 'Casing ID',
    col_unit: '-',
    ui_editable: false,
    ui_show: false,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'casing_type',
    col_name: 'Casing Type',
    col_desc: 'Casing Type',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'cement_id',
    col_name: 'Cement ID #',
    col_desc: 'Cement ID #',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'stage',
    col_name: 'Stage',
    col_desc: 'Stage',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'fluid_type',
    col_name: 'Fluid Type',
    col_desc: 'Fluid Type',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'q',
    col_name: 'Flow Rate',
    col_desc: 'Fluid Flow Rate',
    col_unit: 'bpm',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'vol',
    col_name: 'Volume',
    col_desc: 'Fluid Volume',
    col_unit: 'bbl',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 't',
    col_name: 'Pumping Time',
    col_desc: 'Fluid Pumping Time',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'den',
    col_name: 'Density',
    col_desc: 'Fluid Density',
    col_unit: 'ppg',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'top_depth',
    col_name: 'Fluid Top Depth',
    col_desc: 'Top Depth of Fluid',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'bottom_depth',
    col_name: 'Fluid Bottom Depth',
    col_desc: 'Bottom Depth of Fluid',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'm',
    col_name: 'Fluid Weight',
    col_desc: 'Fluid Weight',
    col_unit: 'lb',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'm_cement',
    col_name: 'Dry Cement Weight',
    col_desc: 'Dry Cement Weight',
    col_unit: 'lb',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 's_cement',
    col_name: 'Dry Cement Volume',
    col_desc: 'Dry Cement Volume',
    col_unit: 'sk',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 'percent_water',
    col_name: 'Water Percentage',
    col_desc: 'Water Percentage in Cement',
    col_unit: '%',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_key_info',
    col_id: 't_mix',
    col_name: 'Mixing Time',
    col_desc: 'Cement Mixing Time',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'int',
    decimal: 0
  }
];

export default SCHEMA_KEY_INFO;
